import React from 'react'
import { Popover, Transition } from "@headlessui/react"
import { BuildingOfficeIcon } from '@heroicons/react/24/outline';
interface RoomData {
    codigo_habitacion: string;
    tipo_habitacion: string;
    cantidad_ocupantes: number;
    selected_distribution: string;
    informacion: string;
}

const camaSimpleSVG = (
    <svg width="20" height="30" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 80">
        <title>Bed-hotel-single bed-sleep</title>
        <g>
            <title>Layer 1</title>
            <g id="svg_1">
                <path d="m49,9l-34,0a2,2 0 0 0 -2,2l0,56a2,2 0 0 0 2,2l34,0a2,2 0 0 0 2,-2l0,-56a2,2 0 0 0 -2,-2zm-34,19l34,0l0,4l-34,0l0,-4zm34,-17l0,15l-34,0l0,-15l34,0zm-34,56l0,-33l34,0l0,33l-34,0z" id="svg_2" />
                <path d="m26,24l12,0a3,3 0 0 0 3,-3l0,-5a3,3 0 0 0 -3,-3l-12,0a3,3 0 0 0 -3,3l0,5a3,3 0 0 0 3,3zm-1,-8a1,1 0 0 1 1,-1l12,0a1,1 0 0 1 1,1l0,5a1,1 0 0 1 -1,1l-12,0a1,1 0 0 1 -1,-1l0,-5z" id="svg_3" />
            </g>
        </g>
    </svg>
);

const camaDobleSVG = (
    <svg width="18" height="30" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 80">
        <title>Bed-bedroom-furniture-hotel-sleep-twin</title>
        <g>
            <title>Layer 1</title>
            <g id="svg_1">
                <path d="m57,11l-50,0a2,2 0 0 0 -2,2l0,56a2,2 0 0 0 2,2l50,0a2,2 0 0 0 2,-2l0,-56a2,2 0 0 0 -2,-2zm-50,19l50,0l0,4l-50,0l0,-4zm50,-17l0,15l-50,0l0,-15l50,0zm-50,56l0,-33l50,0l0,33l-50,0z" id="svg_2" />
                <path d="m14,26l12,0a3,3 0 0 0 3,-3l0,-5a3,3 0 0 0 -3,-3l-12,0a3,3 0 0 0 -3,3l0,5a3,3 0 0 0 3,3zm-1,-8a1,1 0 0 1 1,-1l12,0a1,1 0 0 1 1,1l0,5a1,1 0 0 1 -1,1l-12,0a1,1 0 0 1 -1,-1l0,-5z" id="svg_3" />
                <path d="m38,26l12,0a3,3 0 0 0 3,-3l0,-5a3,3 0 0 0 -3,-3l-12,0a3,3 0 0 0 -3,3l0,5a3,3 0 0 0 3,3zm-1,-8a1,1 0 0 1 1,-1l12,0a1,1 0 0 1 1,1l0,5a1,1 0 0 1 -1,1l-12,0a1,1 0 0 1 -1,-1l0,-5z" id="svg_4" />
            </g>
        </g>
    </svg>
);


export default function SectionGuestDistribution() {
    const rooms: RoomData[] = JSON.parse(sessionStorage.getItem("occupants") || "[]");

    const parseOpcion = (opcion: string) => {
        const sanitizedOption = opcion.replace(/\s+/g, '').toUpperCase();
        const simpleBeds = (sanitizedOption.match(/I/g) || []).length;
        const doubleBeds = (sanitizedOption.match(/X/g) || []).length;

        return { simpleBeds, doubleBeds };
    };

    return (
        <div>

            {
                rooms.map((room, index) => {

                    const bedDistribution = parseOpcion(room.informacion)

                    return (
                       
                        <Popover key={index} className={`flex relative `}>
                            <>
                                <div
                                    className={`flex-1 flex items-center focus:outline-none rounded-b-3xl`}
                                >
                                    <Popover
                                        id="guest-input"
                                        className={`relative z-10 flex-1 flex text-left items-center p-3 space-x-3 focus:outline-none`}
                                    >
                                        <div className="text-neutral-300 dark:text-neutral-400">
                                            <BuildingOfficeIcon className="w-5 h-5 lg:w-7 lg:h-7" />
                                        </div>
                                        <div className="flex-grow">
                                            <span className="block xl:text-lg font-semibold">
                                                Habitación N°: {room.codigo_habitacion.split("-")[1]} 
                                            </span>
                                            <span className="block mt-1 text-sm text-neutral-400 leading-none font-light">
                                                Categoría: {room.tipo_habitacion}
                                            </span>
                                        </div>
                                    </Popover>
                                </div>
                                
                            </>
                                
                        </Popover>
                        
                    )
                })
            }

        </div>
    )
}
